package net.bothosting.docs.pages.community_resources

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initBananaburner_panelPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("community_resources/bananaburner_panel.md", FrontMatterElement.Builder { addScalar("description", "Created by @agentzzrp and @paccman_0"); }))
}

@Page("/community_resources/bananaburner-panel")
@Layout(".components.layouts.DocsLayout")
@Composable
fun Bananaburner_panelPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("bananaburner-panel") }) {
        org.jetbrains.compose.web.dom.Text("BananaBurner Panel")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Thanks to Agent & Paccman")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Created and maintained by community members, this is an unofficial tool.")
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.NOTE, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" Link: ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/relentiousdragon/BananaBurner/tree/main") {
                org.jetbrains.compose.web.dom.Text("https://github.com/relentiousdragon/BananaBurner/tree/main")
            }
            org.jetbrains.compose.web.dom.Br()
            org.jetbrains.compose.web.dom.Br()
            org.jetbrains.compose.web.dom.Text("Updates can be found in its dedicated post ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://discord.com/channels/884145104401608735/1476175295684939807") {
                org.jetbrains.compose.web.dom.Text("https://discord.com/channels/884145104401608735/1476175295684939807")
            }
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("description") }) {
        org.jetbrains.compose.web.dom.Text("Description ")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("An alternative control panel for bot-hosting.net, Collect Coins, Create and Manage your servers and Bot-hosting profile.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("An alternative control panel for bot-hosting.net, Collect Coins, Create and Manage your servers and Bot-hosting profile. Features a customizable UI, and quality of life changes that improve your experience:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Coin history for up to 30 days")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Stats Tracking for total coins collected, coins spent, and more")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("SFTP Password saved locally so it can be viewed whenever you want")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Browser notifications for when a server is created, captcha needs to be solved, etc (disabled by default)")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Coin Collector:")
            org.jetbrains.compose.web.dom.Ul {
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("Collect coins automatically while you're on another tab or window, solve captcha when needed at coin 1, 4 and 9")
                }
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Server Creator:")
            org.jetbrains.compose.web.dom.Ul {
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("Tired of trying to create a server over and over again as a free user and never getting lucky to get a server?")
                    org.jetbrains.compose.web.dom.Ul {
                        org.jetbrains.compose.web.dom.Li {
                            org.jetbrains.compose.web.dom.Text("BananaBurner's server creator automatically tries to get a server for you with respect to rate limits, all you have to do is sit back and do whatever you want in other tabs or windows, average time to get a server for free users this way is around 5-15 minutes (based on several attempts)")
                            org.jetbrains.compose.web.dom.Ul {
                                org.jetbrains.compose.web.dom.Li {
                                    org.jetbrains.compose.web.dom.Text("a browser notification will be sent when a server is successfully created (if enabled)")
                                }
                            }
                        }
                    }
                }
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Server Manager:")
            org.jetbrains.compose.web.dom.Ul {
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("View all your servers and their status, here's the cool part: You don't have to visit control.bot-hosting.net to manage your server")
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("Power your servers, view console, configure startup settings and more you can do at the Pterodactyl panel all from bot-hosting.net")
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("Banana Agent is a kind of process manager for Node.js servers, saves console error logs to a file, has Discord webhook crash alerts, crash detection and recovery and other stuff.")
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("PiP console lets you peel out the console to be on top of every application you have open, to debug while you work.")
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("Other")
                }
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Market:")
            org.jetbrains.compose.web.dom.Ul {
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("Get user created themes and plugins to extend the capabilities of BananaBurner. further")
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("Featured Plugins:")
                    org.jetbrains.compose.web.dom.Ul {
                        org.jetbrains.compose.web.dom.Li {
                            org.jetbrains.compose.web.dom.Text("Discord Bot ID:")
                            org.jetbrains.compose.web.dom.Ul {
                                org.jetbrains.compose.web.dom.Li {
                                    org.jetbrains.compose.web.dom.Text("Show the Discord bot's user and avatar on the server card it's hosted on")
                                }
                            }
                        }
                        org.jetbrains.compose.web.dom.Li {
                            org.jetbrains.compose.web.dom.Text("Bulk Server Manager:")
                            org.jetbrains.compose.web.dom.Ul {
                                org.jetbrains.compose.web.dom.Li {
                                    org.jetbrains.compose.web.dom.Text("Select multiple servers and send a power action to start/restart/stop them")
                                }
                            }
                        }
                        org.jetbrains.compose.web.dom.Li {
                            org.jetbrains.compose.web.dom.Text("Console Hyperlinks:")
                            org.jetbrains.compose.web.dom.Ul {
                                org.jetbrains.compose.web.dom.Li {
                                    org.jetbrains.compose.web.dom.Text("Turn paths and urls into clickable links that open to that file on the specific line in the console")
                                }
                            }
                        }
                        org.jetbrains.compose.web.dom.Li {
                            org.jetbrains.compose.web.dom.Text("Git:")
                            org.jetbrains.compose.web.dom.Ul {
                                org.jetbrains.compose.web.dom.Li {
                                    org.jetbrains.compose.web.dom.Text("Creates a bash file for connecting your Github Repository with the server, get files from your repo on startup")
                                    org.jetbrains.compose.web.dom.Ul {
                                        org.jetbrains.compose.web.dom.Li {
                                            org.jetbrains.compose.web.dom.Text("Console commands if your server is Node.js and has Banana Agent setup, type \"git pull\" or \"git status\" in the console.")
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Quick Actions:")
            org.jetbrains.compose.web.dom.Ul {
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("Customize Quick Actions on the Dashboard, add a server to quickly see it's status or manage it, or select from one of the preset actions.")
                }
            }
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("And more!")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("installation") }) {
        org.jetbrains.compose.web.dom.Text("Installation:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Download ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/relentiousdragon/BananaBurner/tree/main") {
                org.jetbrains.compose.web.dom.Text("this repository")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Turn Dev mode on in your browser, go to Extensions -> Click on \"Load unpacked extension\" and select the cloned folder. (Unarchive if archived)")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Done! 🍌")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The script should also work on phones, that is if you can install the extension on your phone's browser <-- there are some browsers available that allow this. ")
    }
    com.varabyte.kobweb.compose.dom.GenericTag("blockquote") {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("server management functionality will be limited on phones, upon demand we can add it")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Update the same way by downloading the repository again and replacing the old folder with the new one then reload the extension from your browser's extension settings.")
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.NOTE, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" Source code for plugins can be found here: ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/relentiousdragon/banana-burner-plugins/") {
                org.jetbrains.compose.web.dom.Text("https://github.com/relentiousdragon/banana-burner-plugins/")
            }
        }
    }
}
